import { SVGProps } from 'react'

const WalletIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="30"
      height="29"
      viewBox="0 0 30 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.52441 15.997V13.9066C3.52441 11.4054 5.56649 9.36328 8.06774 9.36328H21.9394C24.4407 9.36328 26.4827 11.4054 26.4827 13.9066V15.6466H24.0419C23.3652 15.6466 22.749 15.9124 22.3019 16.3716C21.7944 16.867 21.5044 17.5799 21.5769 18.3412C21.6857 19.6462 22.8819 20.6008 24.1869 20.6008H26.4827V22.0387C26.4827 24.5399 24.4407 26.582 21.9394 26.582H15.3177"
        stroke="#1A1E3D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.52441 14.9943V9.47233C3.52441 8.03441 4.40649 6.75352 5.74774 6.24603L15.3419 2.62103C16.8403 2.05311 18.4473 3.16481 18.4473 4.77189V9.36354"
        stroke="#1A1E3D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.7592 16.875V19.3643C27.7592 20.0288 27.2275 20.5725 26.5509 20.5967H24.1826C22.8776 20.5967 21.6813 19.6421 21.5725 18.3371C21.5 17.5759 21.79 16.863 22.2975 16.3675C22.7446 15.9084 23.3609 15.6426 24.0375 15.6426H26.5509C27.2275 15.6667 27.7592 16.2104 27.7592 16.875Z"
        stroke="#1A1E3D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.95508 14.4941H17.4134"
        stroke="#1A1E3D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.12598 19.9277H10.5785C11.3518 19.9277 11.9801 20.556 11.9801 21.3294V22.8761"
        stroke="#1A1E3D"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.60014 18.459L4.12598 19.9331L5.60014 21.4072"
        stroke="#1A1E3D"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9801 26.3136H5.52765C4.75431 26.3136 4.12598 25.6852 4.12598 24.9119V23.3652"
        stroke="#1A1E3D"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5107 27.7901L11.9849 26.316L10.5107 24.8418"
        stroke="#1A1E3D"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default WalletIcon
